module.exports = __webpack_public_path__ + "240b25f38dd558b44350dccdd7f7e5c0.png";